<template>
    <form @submit.prevent="applyFilter">
      <v-row>
        <v-col cols="12" md="3" lg="3" sm="4" xs="12">
          <date-field
            v-model="startDate"
            :maxDate="maxDate"
            :label="`Enter start date`"
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="3" lg="3" sm="4" xs="12">
          <date-field
            v-model="endDate"
            :minDate="minDate"
            :label="`Enter end date`"
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6" lg="6" sm="4" xs="12">
          <label class="font-weight-medium body-2"> </label>
          <v-text-field
            v-model="enrollmentCode"
            outlined
            label="Search using enquiry / Enrollment Code"
            dense
            hide-details
            @input="updateEnrollmentCode($event)"
          />
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.xs" cols="12" md="12" lg="12" sm="12">
          <v-card-actions class="justify-center">
            <v-btn color="#5d58ef" class="white--text" small dense type="submit">
              <v-icon left>mdi-filter</v-icon>Apply
            </v-btn>
            <v-btn class="md-5" @click="resetApplyFilter" depressed dense small>
              <v-icon left> mdi-restart</v-icon> Reset
            </v-btn>
          </v-card-actions>
        </v-col>
        <v-col v-else cols="12" xs="12" class="px-0">
          <v-row no-gutters>
            <v-col class="mb-2" cols="12" xs="12">
              <v-btn color="#5d58ef" class="white--text" dense style="min-width: 100%" type="submit">
                <v-icon left>mdi-filter</v-icon>Apply
              </v-btn>
            </v-col>
            <v-col cols="12" xs="12">
              <v-btn depressed dense style="min-width: 100%" @click="resetApplyFilter">
                <v-icon left> mdi-restart</v-icon> Reset
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </form>
  </template>
<script>
import moment from 'moment'
import DateField from '@/components/BranchTransferV1/component/date/dateComponent'
import Utils from '@/utils'
import CONSTANTS from '@/utils/constants'
export default {
  name: 'filterComponent',
  components: {
    DateField
  },
  props: {

  },
  data () {
    return {
      startDate: null,
      centerArray: [],
      endDate: null,
      maxDate: moment().format('YYYY-MM-DD'),
      minDate: moment().format('YYYY-MM-DD'),
      enrollmentCode: null
    }
  },
  computed: {
    statusArray: function () {
      return CONSTANTS.WOW_KIT_BOM_CONFIGURATION_STATUS_LIST
    },
    approvalStatusArray: function () {
      return CONSTANTS.WOW_KIT_APPROVER_STATUS_LIST
    }
  },
  watch: {
    startDate: function (newVal) {
      if (newVal) {
        this.minDate = newVal
        this.maxDate = this.endDate
        this.$emit('setStartDate', newVal)
      }
    },
    endDate: function (newVal) {
      if (newVal) {
        this.minDate = this.startDate
        this.maxDate = newVal
        this.$emit('setEndDate', newVal)
      }
    }
  },
  async created () {

  },
  methods: {
    applyFilter: function () {
      this.$emit('callApi')
    },
    updateEnrollmentCode: function (e) {
      this.$emit('setEnrollmentCode', e)
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    resetApplyFilter: function () {
      console.log('Reset Filter')
      this.startDate = null
      this.endDate = null
      this.enrollmentCode = null
      this.$emit('reset')
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>
